import FieldProto from "../../proto/field-proto"
import FieldConfig from "../../proto/field-config"
import FieldStepper_FormElement from "./render/form-element"

export default class FieldStepper extends FieldProto {

    FIELD_DEFAULT_WIDTH = 100

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Stepper"
        this.icon               = 'i5-numbers'

        this.minValue           = _.get(config, 'minValue', undefined)
        this.maxValue           = _.get(config, 'maxValue', undefined)

        this.renderComponents.formElement = FieldStepper_FormElement
    }
}
